import React, {useState, useEffect } from "react";
import { Input, Button, styled, Box, IconButton, FormControl, FormHelperText} from "@mui/material";
import InputBase from "@mui/material/InputBase";
//import { theme } from "material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import Select, { StylesConfig }  from "react-select";
import TableTestForm from "../form/TableTestForm.jsx";

export default function TestForm(props){

const StyledDiv = styled("div")({
  backgroundColor: "grey",
  border: "1px solid black",
  width: "25%",
  height: "30px"
});

const StyledInput = styled(InputBase)({
    width: "99%",
    fontSize: "14px",
    height: "95%",
    
    marginBottom: "1px",
    marginTop: "1px",
    marginLeft: "1px",
    marginRight: "1px",
    borderRadius: "3px"
});


const StyledInputi = styled("input")({
    width: "99%",
    fontSize: "14px",
    height: "95%",
    
    marginBottom: "1px",
    marginTop: "1px",
    marginLeft: "1px",
    marginRight: "1px",
    borderRadius: "3px"
});

const StyledPassword = styled("input")({
    width: "99%",
    fontSize: "14px",
    height: "95%",
    
    marginBottom: "1px",
    marginTop: "1px",
    marginLeft: "1px",
    marginRight: "1px",
    borderRadius: "3px"
});

const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...base,
      backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
      //backgroundColor: isFocused ? "#6BD5C0" : "#320B63",
    };
  }
};

/***
const StyledThemeDiv = styled ("div")(({theme})({

}));
***/
const [tableData1, setTableData1]=useState([
  {
    "id": 1,
    "username": "Saidi",
    "email": "saidi@gmail.com",
    "password": "8900987",
    "status": "Active"
}
]);
const [showTable, setShowTable]=useState(true);

const [tableData, setTableData]=useState([]);
//const [loading, setLoading] = useState(false)
let APIURL='myapi/ulccv'
  let requestOptions={
    method: 'GET',
    headers: {'Content-type': 'application/json'},
  }
  
  function loadData(datasrc){
    console.log("datasrc=" + datasrc);
    console.log("datasrc[0].username=" + datasrc[0].username);
    console.log("datasrc[0].password=" + datasrc[0].password);
    console.log("datasrc[0].status=" + datasrc[0].status);
    console.log("datasrc[0].email=" + datasrc[0].email);
    
    setTableData(datasrc);
    console.log("TableData xxx =" + tableData);
  }

  const [loading1, setLoading1]=useState(false);
  
  useEffect(() => {
    setLoading1(true)
  fetch(APIURL)
  .then( response => response.json())
  .then ( json => loadData(json))
  //.then ( json => console.log(json))
  
  .finally( ()=>{
    setLoading1(true)
  })

},[])

const [UserName, setUserName] = useState(props?.value ?? '');
const [UserEmail, setUserEmail]=useState(props?.value ?? '');
const [UserPassword, setUserPassword]=useState(props?.value ?? '');

const [tableDataOGLoginCategories, setTableDataOGLoginCategories]= useState([]);

const [UserLoginCategory, setUserLoginCategory ]=useState('');

const [dataUrlLoginCategories, setdataUrlLoginCategories]=useState('/myapi/lcv')
  let [data, setData]= useState([]);
  //usestate hook
  const [dataFromSrcLoginCategories, setDataFromSrcLoginCategories] = useState([]);
  const [select, setselect] = useState('');

function loadDataLoginCategories(dataLoaded){
    let selectData=[];
    //selectData.push({'value': '', 'label': ''})
      dataLoaded.map(function(lc){
      return(
        
        selectData.push({value: lc.name, label: lc.name})
        //console.log("lc=" + lc)
      )
    });
    //console.log("datal=" + dataLoaded);
    setDataFromSrcLoginCategories(selectData);
    // setTableDataOGLoginCategories(dataLoaded);
   console.log("selectData=" + selectData);
   console.log("selectData[0].value=" + selectData[0].value + " ::: ");
 };

const [loading, setLoading] = useState(false)

useEffect(() => {
    setLoading(true)
    
    fetch(dataUrlLoginCategories)
      .then(response => response.json())
      .then(json => loadDataLoginCategories(json))
     
      .finally(() => {
        setLoading(true);
      })


  }, [])


  function submitUser(){
     const myObj={
            'username': UserName,
            'email': UserEmail,
            'password': UserPassword,
            'status': UserLoginCategory['value'],
     }
    console.log("myObj=" + myObj);
     const APIPostOptions={
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify(myObj)
     }

     const APIURL="/myapi/crnewsystemuser";
         
     try{
         fetch(APIURL, APIPostOptions)
         .then( (response)=> response.json)
         .then( (data)=> console.log("data=" + data))
        // alert("success");
       }
       catch(Exception){
        console.log("Exception=" + Exception)
       }
  }

    const handleUserNameOnChange=(e)=>{
       console.log("UserName e.target.value=" + e.target.value);
       setUserName(e.target.value);
       console.log("UserName111=" + UserName);
    }
    
    const [searchValueT, setSearchValueT]=useState('');
    
    const handleOnChangeSearchText=(e)=>{
           console.log("searchValue=" + searchValueT);
           setSearchValueT(e.target.value);
           console.log("searchValueT=" + searchValueT);
    }

    const tableCols=[
      {'id': 1, 'title': 'Username', 'width': '25%'},
      {'id': 2, 'title': 'Email', 'width': '25%'},
      {'id': 3, 'title': 'Password', 'width': '25%'},
      {'id': 4, 'title': 'Status', 'width': '25%'},
    ]
    //
    const [checkedStatus, setCheckedStatus] = useState(false); 
    const onChangeChecked = () => { 
      setCheckedStatus(!checkedStatus);
      console.log("fc=" + checkedStatus);
    }; 
    //
    const [checkedStatusR, setCheckedStatusR] = useState(false); 
    const onChangeCheckedR = () => { 
      setCheckedStatusR(!checkedStatusR);
      console.log("fc R=" + checkedStatusR);
    }; 
    //
    
    return(
        <div>
         <form>
         <Box
            display="flex"
           // backgroundColor={colors.primary[400]}
            borderRadius="3px"
         >
            <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" onChange={handleOnChangeSearchText} />
            <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
            </IconButton>
         </Box>
         <br/>
         <label>Over 35</label>
         <input type="radio" placeholder="Over 18" checked={checkedStatusR} 
         onChange={onChangeCheckedR}
         sx={{backgroundColor: "grey"}}
         />
         <br/>
         <label>Over 18</label>
         <input type="checkbox" value="Over 18" placeholder="Over 18" checked={checkedStatus} 
         onChange={onChangeChecked}
         sx={{backgroundColor: "grey"}}
         />
         <br/>
                <InputBase placeholder="Enter UserName" 
                 onChange={handleUserNameOnChange}
                 value={UserName}
                />
            
            <br/>
            
            
                <Input placeholder="Enter Email"
                 onChange={(event)=>{
                    setUserEmail(event.target.value)
                    console.log("UserEmail 999 =" + UserEmail)
                 }}
                 value={UserEmail}
                 sx={{
                  border: "1px solid grey",
                  borderRadius: "3px"
                 }}
                />
            
            <br/>
            
           
                <Input type="password" placeholder="Enter Password" 
                onChange={(event)=>{
                    setUserPassword(event.target.value);
                    console.log("UserPassword 777 =" + UserPassword);
                }}
                value={UserPassword}
             />
           

          
            <br/>
            
            
            <Select
            styles={customStyles}
            options={dataFromSrcLoginCategories}
            onChange={(event)=>{
                console.log("event.value=" + event.value);
                setUserLoginCategory({ 'value' : event.value, 'label' : event.value})
                console.log("userLoginCategory=");
            }}
            />
            
            <br/>
            <Button type="submit" sx={{
                color:"green"
                }} 
                onClick={submitUser}
                > Register </Button>

         </form>

         {showTable && (<div> 
          <TableTestForm tableColumns={tableCols} tableDataP={tableData1} />
            </div> )}

        </div>

        
    )
}